import projectWithManufacturerCameraModels from 'sagas/setupProjectsSaga/projectWithManufacturerCameraModels'
import { expandProjectAction } from 'actions/projectActions'
import { put, select, call } from 'redux-saga/effects'
import { cameraModelsSelector } from 'selectors'
import propEq from 'ramda/src/propEq'
import firstCamerasManufacturer from 'helpers/firstCamerasManufacturer'

function * getManufacturerSpecificCamerModels(manufacturer) {
  const { cameraModels } = yield select(cameraModelsSelector)
  return cameraModels.filter(propEq('manufacturer_path', manufacturer))
}

export function * createSignedInManufacturerSpecificProject(manufacturer) {
  const manufacturerSpecificCameraModels = yield call(getManufacturerSpecificCamerModels, manufacturer)
  return projectWithManufacturerCameraModels(
    firstCamerasManufacturer(manufacturerSpecificCameraModels),
    manufacturerSpecificCameraModels
  )
}

export function * createOfflineManufacturerSpecificProject(manufacturer, active) {
  const manufacturerSpecificCameraModels = yield call(getManufacturerSpecificCamerModels, manufacturer)
  const project = projectWithManufacturerCameraModels(
    firstCamerasManufacturer(manufacturerSpecificCameraModels),
    manufacturerSpecificCameraModels
  )

  yield put(expandProjectAction(project, true, active))
}



// WEBPACK FOOTER //
// ./src/sagas/setupProjectsSaga/handleManufacturerSpecificProject.js